if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"kyc_web_shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(default\-webpack_sharing_consume_default_(angular_(co(mmon_(angular_common|http_angular_common_http)|re_(angular_core|rxjs\-interop_angular_core_rxjs\-interop))|platform\-browser_angular_platform\-browser)|rxjs_(operators_rxjs_operator|rxj)s|ngrx_store_ngrx_store)|vendor)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}